export default "__VITE_ASSET__CW2TUkZ7__"